// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import Notification from '../../../notification';

const IssueReportElement = ({ report, userType, resolveIssueReport, sendIssueAgain }) => {
    const [description, setDescription] = useState('');

    const handlerChanges = (event) => {
        setDescription(event.target.value);
    };

    const resolveIssue = () => {
        if (!description && userType === 'contractor') {
            Notification('warning', { message: 'Add description!' });
            return;
        }
        const resolveData = {
            report_id: report._id,
            work_order_id: report.work_order_id,
            contractor_id: report.contractor_id,
            description,
        };
        resolveIssueReport(userType, resolveData);
    };

    const sendReportIssueAgain = () => {
        const issueInfo = {
            work_order_id: report.work_order_id,
            contractor_id: report.contractor_id,
            report_id: report._id,
            description,
        };
        sendIssueAgain(issueInfo);
    };

    return (
        <div className="line_blocks">
            <div className="block_label">Expenses</div>

            <ul className="info_list">
                <li>
                    <span>Issue Reported</span>
                    <span>{report.client_issue_description}</span>
                </li>
                {report.contractor_resolved_issue_description && (
                    <li>
                        <span>{userType === 'contractor' ? 'You' : 'Contractor'} description</span>
                        <span>{report.contractor_resolved_issue_description}</span>
                    </li>
                )}
            </ul>

            {!report.client_status && (
                <>
                    <div className="field_col" style={{ marginTop: '10px' }}>
                        <label className="field_name">Update your description</label>
                        <div className="field_block">
              <textarea
                  className="form-control"
                  rows="4"
                  name="description"
                  placeholder="Description"
                  value={description}
                  onChange={handlerChanges}
              />
                        </div>
                    </div>

                    <ul className="type_list">
                        <li>
                            <button className="block_type" onClick={resolveIssue}>
                                {report[`${userType}_status`] ? 'Update description' : 'Mark issue as resolved'}
                            </button>
                        </li>
                        {userType === 'client' && (
                            <li>
                                <button className="block_type" onClick={sendReportIssueAgain}>
                                    {report.contractor_status
                                        ? 'Mark Report issue again'
                                        : 'Report another issue'}
                                </button>
                            </li>
                        )}
                    </ul>
                </>
            )}

            {report.client_status && (
                <div className="info_block" style={{ color: 'green', marginTop: '10px' }}>
                    Issue has been resolved
                </div>
            )}
        </div>
    );
};

export default IssueReportElement;
